goog.provide("shadow.js.shim.module$$mui$material$AvatarGroup");
goog.provide("module$shadow_js_shim_module$$mui$material$AvatarGroup");
shadow.js.shim.module$$mui$material$AvatarGroup = shadow.js.nativeProvides["@mui/material/AvatarGroup"] = shadow$bridge("@mui/material/AvatarGroup");
module$shadow_js_shim_module$$mui$material$AvatarGroup.default = shadow.js.shim.module$$mui$material$AvatarGroup;
